interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  placeholder?: string;
  minRows?: number;
}

export function TextAreaComponent(props: TextAreaProps) {
  return <textarea placeholder={props.placeholder} rows={props.rows} className='text-area' {...props} />;
}
